import { waitForAppMeasurement } from "../waitForAppMeasurement"
import { PURCHASE_REQUEST_LINK_TRACK_VARS_BASE } from "./constants"
import type { PurchaseRequestOfferState } from "./getPurchaseRequestOfferState"

interface TrackPurchaseRequestOpenProps {
	/** Whether this open is a revisit (event31) instead of a fresh open (event29) */
	isRevisit: boolean
	/** Model name, e.g. "911 GT3 RS", tracked as eVar17 */
	modelName: string
	/** Model range name, e.g. "911", tracked as eVar18 */
	modelRange: string
	/** Offer state from the viewing dealer's perspective, tracked as eVar198 */
	offerState: PurchaseRequestOfferState
	/** Purchase request ID, tracked as eVar197 to measure open frequency per request */
	purchaseRequestId: string
}

const LINK_TRACK_VARS = `${PURCHASE_REQUEST_LINK_TRACK_VARS_BASE},eVar198`

/**
 * Tracks a dealer opening a purchase request detail page.
 * Fires `event29` on the first open of a purchase request and `event31` on every revisit,
 * where the revisit determination (`isRevisit`) is owned by `registerPurchaseRequestVisit`
 * and persists across browser sessions for the duration of its revisit window.
 * Carries the model (eVar17/eVar18), the purchase request ID (eVar197)
 * and the offer state (eVar198) for engagement and conversion analysis.
 */
export const trackPurchaseRequestOpen = ({
	isRevisit,
	modelName,
	modelRange,
	offerState,
	purchaseRequestId,
}: TrackPurchaseRequestOpenProps) => {
	return waitForAppMeasurement((s) => {
		const event = isRevisit ? "event31" : "event29"

		s.linkTrackVars = LINK_TRACK_VARS
		s.linkTrackEvents = event
		s.events = event

		s.eVar17 = modelName
		s.eVar18 = modelRange
		s.eVar197 = purchaseRequestId
		s.eVar198 = offerState

		s.tl(true, "o", `syp_detail_page ${isRevisit ? "revisit" : "open"}`)

		// values are sticky, reset them afterward
		s.linkTrackVars = ""
		s.linkTrackEvents = ""
		s.events = ""
		s.eVar17 = undefined
		s.eVar18 = undefined
		s.eVar197 = undefined
		s.eVar198 = undefined
	})
}
